// PIX EMV BR Code generator (PIX Copia-e-Cola).
// Reference: Manual PIX BACEN — EMVCo TLV format.

function tlv(id, value) {
  const len = String(value.length).padStart(2, "0");
  return `${id}${len}${value}`;
}

function crc16(payload) {
  let crc = 0xffff;
  for (let i = 0; i < payload.length; i++) {
    crc ^= payload.charCodeAt(i) << 8;
    for (let j = 0; j < 8; j++) {
      crc = crc & 0x8000 ? (crc << 1) ^ 0x1021 : crc << 1;
      crc &= 0xffff;
    }
  }
  return crc.toString(16).toUpperCase().padStart(4, "0");
}

function sanitize(s, max) {
  return (s || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-zA-Z0-9 ]/g, "")
    .toUpperCase()
    .slice(0, max);
}

/**
 * Build a PIX BR Code (EMV) string for "Copia e Cola" / QR Code.
 * @param {object} args
 * @param {string} args.key       - PIX key (CPF/CNPJ/email/phone/random)
 * @param {string} args.name      - Merchant name (max 25 chars)
 * @param {string} args.city      - Merchant city (max 15 chars)
 * @param {number} [args.amount]  - Optional amount (BRL)
 * @param {string} [args.txid]    - Optional transaction id (max 25 chars)
 * @returns {string} BR Code payload
 */
export function buildPixBRCode({ key, name, city, amount, txid }) {
  if (!key) return "";
  const merchantAccount = tlv("00", "BR.GOV.BCB.PIX") + tlv("01", key);
  const additional = tlv("05", sanitize(txid || "***", 25) || "***");

  let payload = "";
  payload += tlv("00", "01"); // Payload Format Indicator
  payload += tlv("26", merchantAccount); // Merchant Account Information
  payload += tlv("52", "0000"); // Merchant Category Code
  payload += tlv("53", "986"); // Currency BRL
  if (amount && Number(amount) > 0) {
    payload += tlv("54", Number(amount).toFixed(2));
  }
  payload += tlv("58", "BR"); // Country
  payload += tlv("59", sanitize(name, 25) || "ASSISTENCIA"); // Merchant Name
  payload += tlv("60", sanitize(city, 15) || "SAO PAULO"); // Merchant City
  payload += tlv("62", additional); // Additional Data
  payload += "6304"; // CRC placeholder
  return payload + crc16(payload);
}
